import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Users, Briefcase, Percent, History } from "lucide-react";
import { CommissionSection } from "@/components/concierge/CommissionSection";
import { AllDepositsSection } from "@/components/concierge/AllDepositsSection";
import { Button } from "@/components/ui/button";
import { conciergeApi, TOKEN_KEY } from "@/components/concierge/api";
import { StaffSection } from "@/components/concierge/StaffSection";
import { CompanySection } from "@/components/concierge/CompanySection";
import { DepositForm } from "@/components/concierge/DepositForm";

const TABS = [
  { key: "staff", icon: Users, label: "Admin" },
  { key: "pro", icon: Briefcase, label: "Client pro" },
  { key: "commission", icon: Percent, label: "Ma part" },
  { key: "history", icon: History, label: "Historique" },
];

export default function ConciergePortal() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [tab, setTab] = useState("staff");
  const [person, setPerson] = useState(null);
  const [company, setCompany] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) { navigate("/etoile"); return; }
    conciergeApi.get("/me").then((r) => setName(r.data.name)).catch(() => {});
  }, [navigate]);

  const logout = () => { localStorage.removeItem(TOKEN_KEY); navigate("/etoile"); };

  return (
    <div className="min-h-screen bg-slate-50" data-testid="concierge-portal">
      <header className="bg-slate-900 text-white">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-3">
          <img src="https://customer-assets-rejwkqb3.emergentagent.net/job_2865d04f-1753-4ac2-b4d4-74d332d7faa7/artifacts/d20c424927cac4c3_t%C3%A9l%C3%A9chargement.jpg" alt="Formation Pressing Sakura & L'Étoile Part-Dieu" className="h-20 bg-white rounded-lg" data-testid="concierge-header-logo" />
          <div>
            <p className="font-bold" data-testid="concierge-name">{name}</p>
            <p className="text-xs text-slate-300">Espace partenaire Pressing Sakura</p>
          </div>
          <Button variant="ghost" size="sm" className="ml-auto text-white hover:bg-white/10" onClick={logout} data-testid="concierge-logout-btn"><LogOut className="w-4 h-4 mr-1" />Déconnexion</Button>
        </div>
      </header>
      <main className="max-w-4xl mx-auto p-4 space-y-5">
        {person ? (
          <DepositForm person={person} onBack={() => setPerson(null)} />
        ) : (
          <>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
              {TABS.map((t) => {
                const Icon = t.icon;
                return (
                  <button key={t.key} onClick={() => setTab(t.key)} data-testid={`concierge-tab-${t.key}`}
                    className={`flex items-center justify-center gap-2 py-3 rounded-xl font-semibold transition-colors ${tab === t.key ? "bg-pink-600 text-white shadow" : "bg-white text-slate-600 border"}`}>
                    <Icon className="w-5 h-5" />{t.label}
                  </button>
                );
              })}
            </div>
            {tab === "staff" && <StaffSection onOpen={setPerson} />}
            {tab === "pro" && <CompanySection onOpen={setPerson} current={company} setCurrent={setCompany} />}
            {tab === "commission" && <CommissionSection />}
            {tab === "history" && <AllDepositsSection />}
          </>
        )}
      </main>
    </div>
  );
}
